"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteQuestionFiles = exports.getQuestionFiles = exports.excludeQuestions = exports.answerQuestions = exports.addQuestion = exports.listQuestions = void 0;
const t = require("io-ts");
const fp = require("fp-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/bid/questions");
const Actions = require("../../actions/bid/questions");
const _fileList = require("../../modules/files/list/epics");
const _fileCrud = require("../../modules/files/crud/epics");
const validation_1 = require("../../utils/validation");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
function listQuestions(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/bid/${action.payload.id}/question`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const validation = t.array(sok_types_1.Bid.iQuestion).decode(xhr.response);
        const act = validation.fold((e) => Actions.fetchFailed((0, errorHandling_1.parseValidationError)(e)), (questions) => Actions.fetchSuccess(questions));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.listQuestions = listQuestions;
function validateCreateQuestion(action) {
    return fp.function.compose((x) => {
        if (action.payload.question.answer !== null) {
            return (0, validation_1.ap)((0, validation_1.isNotEmpty)('answer')(action.payload.question))(x);
        }
        return x;
    }, (0, validation_1.ap)((0, validation_1.hasInvalidLength)('question', 0, 25000)(action.payload.question.question)))((0, validation_1.isNotEmpty)('question')(action.payload.question));
}
function addQuestion(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.ADD_QUESTION_REQUEST), (0, operators_1.mergeMap)((action) => validateCreateQuestion(action).fold((e) => (0, rxjs_1.of)(Actions.addQuestionValidationFailed(e)), () => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: action.payload.question,
        url: `${baseUrl}api/bid/${action.payload.bid.id}/question`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const validation = sok_types_1.Bid.iQuestion.decode(xhr.response);
        return validation.fold((e) => (0, rxjs_1.of)(Actions.addQuestionFailed((0, errorHandling_1.parseValidationError)(e))), (_) => (0, rxjs_1.merge)((0, rxjs_1.of)(Actions.addQuestionSuccess(), Actions.fetchRequest(action.payload.bid)), (0, rxjs_1.of)(Actions.toggleAddQuestion(false)).pipe((0, operators_1.delay)(500))));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.addQuestionFailed((0, errorHandling_1.parseAjaxErrorResponse)(error))))))));
}
exports.addQuestion = addQuestion;
function validateAnswerQuestion(action) {
    return action.payload.questions.reduce((acc, item) => {
        return (0, validation_1.ap)((0, validation_1.isNotEmpty)('answer')(item))(acc);
    }, validation_1.successValidation);
}
function answerQuestions(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.ANSWER_QUESTION_REQUEST), (0, operators_1.mergeMap)((action) => validateAnswerQuestion(action).fold((e) => (0, rxjs_1.of)(Actions.answerQuestionValidationFailed(e)), () => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: action.payload.questions,
        url: `${baseUrl}api/bid/${action.payload.bid.id}/question`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const validation = t.array(sok_types_1.Bid.iQuestion).decode(xhr.response);
        return validation.fold((e) => (0, rxjs_1.of)(Actions.answerQuestionFailed((0, errorHandling_1.parseValidationError)(e))), () => (0, rxjs_1.merge)((0, rxjs_1.of)(Actions.answerQuestionSuccess(), Actions.fetchRequest(action.payload.bid)), (0, rxjs_1.of)(Actions.toggleAnswerQuestion([], false)).pipe((0, operators_1.delay)(500))));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.answerQuestionFailed((0, errorHandling_1.parseAjaxErrorResponse)(error))))))));
}
exports.answerQuestions = answerQuestions;
function excludeQuestions(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.TOGGLE_EXCLUDE_STATUS_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: action.payload.questions,
        url: `${baseUrl}api/bid/${action.payload.bid.id}/question/exclude`
    }).pipe((0, operators_1.mergeMap)((xhr) => {
        const validation = t.array(sok_types_1.Bid.iQuestion).decode(xhr.response);
        return validation.fold((e) => (0, rxjs_1.of)(Actions.toggleExcludeStatusFailed((0, errorHandling_1.parseValidationError)(e))), () => (0, rxjs_1.of)(Actions.toggleExcludeStatusSuccess(), Actions.fetchRequest(action.payload.bid)));
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.toggleExcludeStatusFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.excludeQuestions = excludeQuestions;
const fileList = _fileList.default('bid-answer-file');
const fileCrud = _fileCrud.default('bid-answer-file');
exports.getQuestionFiles = fileList.fetch;
exports.deleteQuestionFiles = fileCrud.deleteFile;
//# sourceMappingURL=questions.js.map